import { Component, contentChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent } from '../../../icon/icon.component';
import { EmptyIconDirective } from './empty-icon.directive';

@Component({
  selector: 'td-wb-empty',
  templateUrl: 'empty.component.html',
  styleUrls: ['empty.component.scss'],
  imports: [NgTemplateOutlet, IconComponent]
})
export class EmptyComponent {
  readonly customIcon = contentChild(EmptyIconDirective);
}
